import { useNavigate } from "react-router-dom";
import SeoHead from "@/components/feature/SeoHead";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://www.crownhongyunmall.com";

const termsJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "用户协议 | 皇冠鸿运商城",
  "description": "皇冠鸿运商城用户协议，规定用户使用平台服务的权利与义务、禁止行为、争议解决等条款。",
  "url": `${SITE_URL}/terms`,
  "inLanguage": "zh-CN",
  "dateModified": "2026-04-11",
  "isPartOf": { "@type": "WebSite", "name": "皇冠鸿运商城", "url": SITE_URL },
};

const sections = [
  {
    title: "一、服务说明",
    icon: "ri-store-2-line",
    content: [
      "皇冠鸿运商城（以下简称【平台】）是由广东皇冠鸿运科技有限公司运营的综合电商平台，提供以下服务：",
      "**商品购买**：浏览、搜索、购买平台上工厂直营的正品商品。",
      "**工厂入驻**：具备合法资质的工厂可申请入驻，在平台销售自有品牌商品。",
      "**达人分销**：内容创作者可加入分销计划，推广商品赚取佣金。",
      "**教育书籍**：购买高考、研究生、会计、英语等考试备考书籍及感恩教育书籍。",
      "**爱心捐赠**：为偏远山村婴儿捐赠奶粉、图书等爱心礼物。",
      "**Crowntalk**：使用平台官方社交通讯应用与全球用户互动。",
    ],
  },
  {
    title: "二、账户注册与安全",
    icon: "ri-user-add-line",
    content: [
      "使用平台服务前，您需要注册账户并遵守以下规定：",
      "**真实信息**：注册时必须提供真实、准确、完整的个人信息，不得冒用他人身份。",
      "**账户安全**：您有责任妥善保管账户密码，不得将账户转让或出借给他人使用。",
      "**年龄要求**：您必须年满18周岁方可注册使用平台服务；未成年人须在监护人同意下使用。",
      "**一人一号**：每位用户只能注册一个账户，不得通过多账户规避平台规则。",
      "**账户异常**：如发现账户被盗用或异常登录，请立即联系客服并修改密码。",
      "平台有权在发现账户信息虚假或违规时，暂停或终止该账户的使用权限。",
    ],
  },
  {
    title: "三、购买与支付",
    icon: "ri-shopping-cart-line",
    content: [
      "在平台购买商品时，您需了解以下规则：",
      "**下单确认**：提交订单即表示您同意以标注价格购买该商品，订单一旦确认不可随意取消。",
      "**价格说明**：商品价格以下单时页面显示为准，平台保留因系统错误导致的价格异常订单的取消权利。",
      "**支付安全**：平台支持支付宝、微信支付等合规支付方式，所有支付均通过加密通道处理。",
      "**货款托管**：买家付款后资金进入平台托管账户，确认收货后才释放给工厂，保障买家权益。",
      "**发票开具**：如需发票，请在下单时备注，平台将协助工厂为您开具合规发票。",
    ],
  },
  {
    title: "四、配送与收货",
    icon: "ri-truck-line",
    content: [
      "**配送范围**：平台支持中国大陆地区配送，部分商品支持港澳台及海外配送（以商品页面说明为准）。",
      "**配送时效**：一般商品下单后1–3个工作日发货，偏远地区可能需要额外时间。",
      "**收货确认**：请在收货后仔细检查商品，如有问题请在签收后7天内联系客服处理。",
      "**拒收处理**：无故拒收商品产生的退货运费由买家承担；因商品质量问题拒收的运费由工厂承担。",
      "**地址变更**：订单发货后不支持修改收货地址，请在下单前仔细核对地址信息。",
    ],
  },
  {
    title: "五、退换货政策",
    icon: "ri-refresh-line",
    content: [
      "平台提供7天无理由退换货保障（以下情况除外）：",
      "**支持退换**：商品存在质量问题、与描述严重不符、收到损坏商品等情况，平台全额退款并承担运费。",
      "**7天无理由**：非质量问题的退货，商品须保持原包装完好、未使用状态，买家承担退货运费。",
      "**不支持退换**：定制商品、食品生鲜、数字内容（已激活）、因买家原因导致损坏的商品。",
      "**退款时效**：退款将在平台确认收到退货后3–5个工作日内原路退回。",
      "**纠纷处理**：如买卖双方对退换货存在争议，可申请平台介入调解，平台将在7个工作日内给出处理意见。",
    ],
  },
  {
    title: "六、禁止行为",
    icon: "ri-forbid-line",
    content: [
      "使用平台服务时，您不得从事以下行为：",
      "**虚假信息**：发布虚假商品信息、伪造评价、刷单炒信等欺骗行为。",
      "**侵权行为**：销售侵犯他人知识产权的商品，包括仿冒品、山寨品。",
      "**违禁商品**：销售法律法规禁止销售的商品，包括但不限于违禁药品、武器等。",
      "**恶意操作**：利用技术手段攻击平台系统、爬取数据、干扰正常运营。",
      "**账户滥用**：通过多账户套取优惠、恶意退款、骚扰其他用户等行为。",
      "**违法内容**：发布违反法律法规的内容，包括色情、赌博、诈骗等。",
      "违反上述规定的用户，平台有权立即封号、追缴违规所得，情节严重者将移交司法机关处理。",
    ],
  },
  {
    title: "七、知识产权",
    icon: "ri-copyright-line",
    content: [
      "平台上的所有内容（包括但不限于文字、图片、视频、代码、商标、Logo）均受知识产权法律保护：",
      "**平台内容**：皇冠鸿运商城的品牌标识、界面设计、技术代码等归平台所有，未经授权不得复制或使用。",
      "**用户内容**：您发布的评价、图片等内容，您保留所有权，但授予平台在全球范围内免费使用的许可。",
      "**工厂内容**：工厂上传的商品图片、描述等内容，工厂保证拥有合法权利，并对侵权行为承担责任。",
      "如您发现平台上存在侵犯您知识产权的内容，请通过 legal@crownhongyunmall.com 联系我们，我们将在48小时内处理。",
    ],
  },
  {
    title: "八、免责声明",
    icon: "ri-alert-line",
    content: [
      "在法律允许的范围内，平台对以下情况不承担责任：",
      "**不可抗力**：因自然灾害、政府行为、网络故障等不可抗力导致的服务中断或损失。",
      "**第三方行为**：因工厂卖家、物流公司等第三方的行为导致的损失（但平台将协助维权）。",
      "**用户行为**：因用户违规操作、账户信息泄露等自身原因导致的损失。",
      "**间接损失**：平台不对任何间接损失、利润损失、数据丢失等承担赔偿责任。",
      "平台的最大赔偿责任不超过您在争议发生前12个月内在平台的实际消费金额。",
    ],
  },
  {
    title: "九、协议变更与终止",
    icon: "ri-edit-line",
    content: [
      "**协议变更**：平台有权随时修改本协议，修改后的协议将在平台公告后30天生效。继续使用服务即表示接受修改。",
      "**服务终止**：平台有权在提前30天通知的情况下终止服务；如用户严重违规，平台可立即终止服务。",
      "**账户注销**：您可以随时申请注销账户，注销后您的个人数据将在90天内删除（法律要求保留的除外）。",
      "**协议存续**：协议终止后，关于知识产权、免责声明、争议解决等条款仍然有效。",
    ],
  },
  {
    title: "十、争议解决",
    icon: "ri-scales-line",
    content: [
      "**适用法律**：本协议受中华人民共和国法律管辖，不适用法律冲突原则。",
      "**协商解决**：发生争议时，双方应首先通过友好协商解决；协商不成的，任一方可向平台客服申请调解。",
      "**仲裁**：如调解不成，争议提交广州仲裁委员会，按其仲裁规则进行仲裁，仲裁裁决为终局裁决。",
      "**管辖法院**：如不适用仲裁，争议提交广东省广州市有管辖权的人民法院诉讼解决。",
      "本协议最后更新日期：**2026年4月11日**。",
    ],
  },
];

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <SeoHead
        title="用户协议 | 服务条款与使用规则 | 皇冠鸿运商城"
        description="皇冠鸿运商城用户协议，规定用户使用平台服务的权利与义务、购买规则、退换货政策、禁止行为及争议解决方式，请在使用前仔细阅读。"
        keywords="用户协议,服务条款,使用规则,退换货政策,皇冠鸿运商城"
        canonical="/terms"
        jsonLd={termsJsonLd}
      />

      {/* Header */}
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 py-10">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-gray-400 hover:text-white text-sm mb-6 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-line"></i> 返回首页
          </button>
          <div className="flex items-center gap-4 mb-3">
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl">
              <i className="ri-file-text-line text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                用户协议
              </h1>
              <p className="text-gray-400 text-sm">Terms of Service</p>
            </div>
          </div>
          <p className="text-gray-300 text-sm leading-relaxed max-w-2xl">
            本协议是您与皇冠鸿运商城之间关于使用平台服务的法律协议。请在使用服务前仔细阅读，使用即表示您同意本协议的全部条款。
          </p>
          <div className="flex items-center gap-4 mt-4 flex-wrap">
            <span className="flex items-center gap-1.5 text-gray-400 text-xs">
              <i className="ri-calendar-line"></i>
              最后更新：2026年4月11日
            </span>
            <span className="flex items-center gap-1.5 text-gray-400 text-xs">
              <i className="ri-file-text-line"></i>
              版本：V3.2
            </span>
          </div>
        </div>
      </div>

      {/* Quick nav */}
      <div className="bg-white border-b border-gray-100 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            <span className="text-gray-400 text-xs whitespace-nowrap">快速导航：</span>
            {sections.map((s, i) => (
              <a
                key={i}
                href={`#term-${i}`}
                className="text-xs text-gray-500 hover:text-gray-800 whitespace-nowrap px-2 py-1 rounded hover:bg-gray-100 transition-colors cursor-pointer"
              >
                {s.title.split("、")[1]}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-10">
        {/* Intro box */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-5 mb-8 flex items-start gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
            <i className="ri-alert-line text-amber-600 text-lg"></i>
          </div>
          <div>
            <p className="text-amber-800 font-semibold text-sm mb-1">使用前请阅读</p>
            <p className="text-amber-700 text-sm leading-relaxed">
              本协议具有法律约束力。注册账户或使用平台服务即表示您已阅读、理解并同意本协议的全部条款。
              如您不同意任何条款，请立即停止使用平台服务。如有疑问，请联系
              <strong> legal@crownhongyunmall.com</strong>。
            </p>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, idx) => (
            <div
              key={idx}
              id={`term-${idx}`}
              className="bg-white rounded-2xl p-6 border border-gray-100"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-xl flex-shrink-0">
                  <i className={`${section.icon} text-gray-600 text-lg`}></i>
                </div>
                <h2 className="text-gray-900 font-bold text-base" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                  {section.title}
                </h2>
              </div>
              <div className="space-y-2.5 pl-1">
                {section.content.map((line, li) => {
                  const isBold = line.startsWith("**") && line.includes("**：");
                  if (isBold) {
                    const [boldPart, ...rest] = line.split("**：");
                    const label = boldPart.replace(/\*\*/g, "");
                    return (
                      <div key={li} className="flex items-start gap-2">
                        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          <strong className="text-gray-800">{label}：</strong>
                          {rest.join("**：")}
                        </p>
                      </div>
                    );
                  }
                  if (line.startsWith("**") && line.endsWith("**")) {
                    return (
                      <p key={li} className="text-gray-700 font-semibold text-sm">
                        {line.replace(/\*\*/g, "")}
                      </p>
                    );
                  }
                  return (
                    <p key={li} className="text-gray-600 text-sm leading-relaxed">
                      {line.replace(/\*\*/g, "")}
                    </p>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-8 bg-gray-800 rounded-2xl p-6 text-white">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl">
              <i className="ri-customer-service-line text-xl"></i>
            </div>
            <h3 className="font-bold text-lg" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              法律与合规联系方式
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: "ri-mail-line", label: "法务邮箱", value: "legal@crownhongyunmall.com" },
              { icon: "ri-global-line", label: "官方网站", value: "www.crownhongyunmall.com" },
              { icon: "ri-building-line", label: "运营主体", value: "广东皇冠鸿运科技有限公司" },
            ].map((item) => (
              <div key={item.label} className="bg-white/10 rounded-xl p-3">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${item.icon} text-gray-400 text-sm`}></i>
                  <span className="text-gray-400 text-xs">{item.label}</span>
                </div>
                <p className="text-white font-medium text-sm">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Related links */}
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <a href="/privacy" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-shield-user-line"></i> 隐私政策
          </a>
          <span className="text-gray-300">|</span>
          <a href="/" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-home-line"></i> 返回首页
          </a>
          <span className="text-gray-300">|</span>
          <a href="/products" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-shopping-bag-line"></i> 商品列表
          </a>
        </div>
      </div>
    </div>
  );
}